(() => {
  const instances = new WeakMap();
  function initialize(root) {
    root.querySelectorAll('[data-lt-reels]').forEach(section => {
      if (instances.has(section)) return;
      const track = section.querySelector('[data-reels-track]');
      const cards = [...section.querySelectorAll('[data-reel]')];
      const preference = matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const ratios = new Map();
      let drag = null, suppressClick = false;
      const load = video => { if (!video.getAttribute('src')) video.src = video.dataset.src; };
      const updateButton = card => {
        const video = card.querySelector('video'), button = card.querySelector('[data-reel-play]');
        button.dataset.playing = String(!video.paused);
        button.setAttribute('aria-pressed', String(!video.paused));
        button.setAttribute('aria-label', `${video.paused ? 'Reproduzir' : 'Pausar'} vídeo: ${video.getAttribute('aria-label')}`);
      };
      const play = card => {
        const video = card.querySelector('video');
        load(video); video.muted = true;
        video.play().catch(() => updateButton(card));
      };
      const resumeVisible = () => {
        if (document.hidden) return;
        cards.forEach(card => {
          if ((ratios.get(card) || 0) >= .6 && card.dataset.userPaused !== 'true' && !preference.matches) play(card);
        });
      };
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const card = entry.target, video = card.querySelector('video');
          ratios.set(card, entry.intersectionRatio);
          if (entry.isIntersecting) load(video);
          if (!document.hidden && entry.intersectionRatio >= .6 && !preference.matches && card.dataset.userPaused !== 'true') play(card);
          else if (!entry.isIntersecting || entry.intersectionRatio < .35 || document.hidden) video.pause();
        });
      }, { threshold: [0, .35, .6, 1] }) : null;
      cards.forEach(card => {
        const video = card.querySelector('video'), button = card.querySelector('[data-reel-play]');
        video.muted = true; button.hidden = false;
        button.addEventListener('click', () => {
          card.dataset.userPaused = String(!video.paused);
          if (video.paused) play(card); else video.pause();
        }, options);
        video.addEventListener('play', () => updateButton(card), options);
        video.addEventListener('pause', () => updateButton(card), options);
        video.addEventListener('volumechange', () => { if (!video.muted) video.muted = true; }, options);
        updateButton(card); observer?.observe(card);
      });
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const step = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        const left = event.key === 'Home' ? 0 : event.key === 'End' ? track.scrollWidth - track.clientWidth : track.scrollLeft + (event.key === 'ArrowRight' ? step : -step);
        track.scrollTo({ left, behavior: preference.matches ? 'instant' : 'smooth' });
      }, options);
      track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a, button')) return;
        drag = { pointer: event.pointerId, x: event.clientX, left: track.scrollLeft, moved: false };
      }, options);
      track.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.pointer) return;
        const delta = event.clientX - drag.x;
        if (!drag.moved && Math.abs(delta) > 6) { drag.moved = true; track.classList.add('is-dragging'); track.setPointerCapture(event.pointerId); }
        if (drag.moved) { event.preventDefault(); track.scrollLeft = drag.left - delta; }
      }, options);
      const stopDrag = event => {
        if (!drag || event.pointerId !== drag.pointer) return;
        if (drag.moved) {
          suppressClick = true;
          const step = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
          track.classList.remove('is-dragging');
          track.scrollTo({ left: Math.round(track.scrollLeft / step) * step, behavior: preference.matches ? 'instant' : 'smooth' });
          setTimeout(() => { suppressClick = false; }, 0);
        }
        drag = null;
      };
      window.addEventListener('pointerup', stopDrag, options);
      window.addEventListener('pointercancel', stopDrag, options);
      track.addEventListener('click', event => { if (suppressClick) { event.preventDefault(); event.stopPropagation(); } }, { ...options, capture: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) cards.forEach(card => card.querySelector('video').pause()); else resumeVisible();
      }, options);
      preference.addEventListener('change', () => {
        if (preference.matches) cards.forEach(card => card.querySelector('video').pause()); else resumeVisible();
      }, options);
      instances.set(section, () => { controller.abort(); observer?.disconnect(); cards.forEach(card => card.querySelector('video').pause()); instances.delete(section); });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-lt-reels]').forEach(section => instances.get(section)?.()));
})();
